// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"822":"d8bd427a","947":"bf2ef13b"}[chunkId] + ".chunk.css";
};